import { getFileList } from './actions';
import { DELETE_UPLOAD_PENDING, DELETE_UPLOAD_FULFILLED, DELETE_UPLOAD_REJECTED } from './actions';

export const reducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case getFileList.pending.type:
      return {
        ...state,
        isFetching: true
      };
    case getFileList.fulfilled.type:
      return {
        ...state,
        isFetching: false,
        hasError: false,
        data: action.payload.deliveryInfoList,
        pages: action.payload.numberOfPages
      };
    case getFileList.rejected.type:
      return {
        ...state,
        isFetching: false,
        hasError: true,
        error: action.error
      };
    case DELETE_UPLOAD_PENDING:
      return {
        ...state,
        isFetching: true
      };
    case DELETE_UPLOAD_FULFILLED:
      return {
        data: state.data.filter(upload => upload.deliveryId !== action.deliveryId),
        isFetching: false,
      };
    case DELETE_UPLOAD_REJECTED:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state;
  }
};